import lozad from "../../plugins/lozad";
import { detectWebP } from "../../helper/featureDetect";

Vue.component("lazy-img", {
    props: {
        imageUrl: String,
        fallbackUrl: String,
        isBackgroundImage: Boolean,
        pictureClass: String,
        alt: String,
        title: String,
        width: String,
        height: String
    },

    data()
    {
        return {
            supported: undefined
        }
    },

    mounted()
    {
        detectWebP(((supported) =>
        {
            this.supported = supported;
            this.$nextTick(() =>
            {
                if(!this.isBackgroundImage)
                {
                    this.$el.classList.toggle("lozad");
                }
                var width = this.width;
                var height = this.height;
                lozad(this.$el, {
                    loaded: function(el) {
                        
                        //el.width = this.width;
                        //el.height = this.height;
                        // Custom implementation to load an element
                        // e.g. el.src = el.getAttribute('data-src');
                        //el.querySelector('img').width = this.width;
                        //console.log(this.width);
                        
                        if(width != undefined && width != ""){
                            el.querySelector('img').setAttribute('width', width);
                            el.querySelector('img').setAttribute('height', height);
                        }
                    }
                }).observe();//.observe();
            });
        }));
    },

    watch:
    {
        imageUrl()
        {
            
            this.$nextTick(() =>
            {
                this.$el.setAttribute("data-loaded", false);
                lozad(this.$el).triggerLoad(this.$el);
            });
        }
    },

    computed: {
        /**
         *  Determine appropriate image url to use as background source
         */
        backgroundSource() {
            if(this.imageUrl && this.mimeType){
                return this.supported ? this.imageUrl : this.fallbackUrl;
            } else {
                return this.imageUrl || this.fallbackUrl;
            }
        },

        /**
         * Check if url points to a .webp image and return appropriate mime-type
         */
        mimeType() {
            const matches = this.imageUrl?.match(/.?(\.\w+)(?:$|\?)/);

            if(matches)
            {
                return matches[1] === ".webp" ? "image/webp" : null;
            }

            return null;
        }
    }
})